export const PLANS = {
  TITLE: 'Plan',
  MONTH: 'Month',
  MONTHS: 'Months',
  CURRENCY: 'EGP',
  BTN: 'Pay',
};
